import React from 'react'

import { FilterHandler } from '@btime/react-contexts'
import PlaceStocksLoader from './_load/PlaceStocksLoader'
import PlaceStocksTable from './table/PlaceStocksTable'
import Scroll from '../../../../components/helpers/Scroll'

const PlaceStocks = () => {
  return (
    <Scroll overflowX={'hidden'} overflowY={'auto'} maxHeight="35rem" width="45rem" height="100%">
      <FilterHandler>
        <PlaceStocksLoader>
          <PlaceStocksTable />
        </PlaceStocksLoader>
      </FilterHandler>
    </Scroll>
  )
}

export default PlaceStocks
